import styled from "styled-components";

export const Body = styled.div`
  align-items: center;
  color: white;
  display: flex;
  flex-direction: column;
  font-size: calc(10px + 2vmin);
  justify-content: center;
  margin-top: 40px;
`;

export const Button = styled.button`
  background-color: #f0bf39;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  margin: 0px 20px;
  padding: 12px 24px;
  text-align: center;
  text-decoration: none;
`;

export const Container = styled.div`
  background-color: #e4e192;
  display: flex;
  flex-direction: column;
  height: calc(100vh);
`;

export const Link = styled.a.attrs({
  target: "_blank",
  rel: "noopener noreferrer",
})`
  color: #61dafb;
  margin-top: 8px;
`;

export const Image = styled.img`
  height: auto; // Keep the original aspect ratio
  width: 10%; // Adjust this value to increase or decrease the size of the logo
  max-width: 120px; // Ensures the image does not become too large
  min-width: 50px; // Ensures the image is not too small to be recognized
  margin-right: 1rem; // Add some space to the right of the logo if it is inline with other elements
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between; // This will push the WalletButton to the right
  padding: 1rem;
  background-color: #fff;
  // Other styles
`;

export const Logo = styled.img`
  height: 50px; // Set a fixed height for your logo
  margin-right: 0.5rem; // Space between the logo and the app name
`;

export const AppName = styled.h1`
  margin: 0; // Remove default margin
  font-size: 1.5rem; // Set the size of the app name text
  color: #333; // Set the color for the app name text
  // You may want to adjust font-family, weight, etc.
`;

export { default as LimitOrderForm } from "./limit-order-form/LimitOrderForm";
export { default as WalletButton } from "./wallet-button/WalletButton";
export { default as MainScreen } from "./main-screen/MainScreen";
export { default as YourPositions } from "./user-positions/UserPositions";
export { default as NetworkModal } from "./network-modal/NetworkModal";